// Header.tsx
import { Button } from "@praticabr/ppsa";
import SelectLang from "../../../../components/UIelements/SelectLang";
import SelectOptions from "../../../../components/UIelements/SelectOptions";
import { useHeaderConfig } from "../../../../context/HeaderContext";
import styles from "./header.module.scss";
import { AiOutlineLeft } from "react-icons/ai";
import { useScreen } from "../../../../context/ScreenContext";

export function Header() {
  const {
    showBack,
    backAction,
    backLabel,
    actions,
    title,
    showTitleOnDesktop,
    showHomeOptionsOnMobile,
    buttons,
    buttonLayout,
  } = useHeaderConfig();
  const { isMobile } = useScreen();

  const hasTitle = Boolean(typeof title === "string" ? title.trim() : title);
  const shouldRenderTitle = Boolean(
    hasTitle && (isMobile || showTitleOnDesktop),
  );
  const hasButtons = Boolean(buttons?.length);
  const hasActions = Boolean(actions?.length);
  const useMobileWrappedButtons = Boolean(
    isMobile && buttonLayout === "mobile-wrapped",
  );
  const hasMobileContent = Boolean(
    showHomeOptionsOnMobile ||
    showBack ||
    shouldRenderTitle ||
    hasButtons ||
    hasActions,
  );

  if (isMobile && !hasMobileContent) return null;

  return (
    <>
      <header
        className={`${styles.header} ${isMobile ? styles.mobile : ""} ${showHomeOptionsOnMobile ? styles.home : ""} ${
          useMobileWrappedButtons ? styles.mobileWrappedButtons : ""
        }`}
      >
        <div className={styles["actions-container"]}>
          {showBack && (
            <button
              className={styles.back}
              onClick={() =>
                backAction ? backAction() : window.history.back()
              }
            >
              <AiOutlineLeft size={isMobile ? 30 : 15} />
              {!isMobile && <p>{backLabel ?? "Voltar"}</p>}
            </button>
          )}

          {(shouldRenderTitle || hasActions) && (
            <div className={styles.titleContainer}>
              {shouldRenderTitle &&
                (typeof title === "string" ? (
                  <h1 className={styles.title}>{title}</h1>
                ) : (
                  title
                ))}

              {hasActions && (
                <div className={styles.actions}>
                  {actions?.map((action) => (
                    <div key={action.id ?? ""} onClick={action.onClick}>
                      {action.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {hasButtons && (
            <div className={styles.buttons}>
              {buttons?.map((button) => (
                <Button
                  variant={button.isActive ? "outline" : "standard"}
                  key={button.id ?? button.label}
                  id={button.id}
                  type="button"
                  onClick={button.onClick}
                  aria-pressed={button.isActive}
                  className={
                    [
                      isMobile && button.fullWidthOnMobile
                        ? styles.fullWidthOnMobile
                        : "",
                      useMobileWrappedButtons && button.isActive
                        ? styles.activeButton
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ") || undefined
                  }
                  size={
                    (button.size as "sm" | "md" | "lg") ??
                    (isMobile ? "md" : "lg")
                  }
                >
                  {button.label}
                </Button>
              ))}
            </div>
          )}
        </div>
        {(!isMobile || showHomeOptionsOnMobile) && (
          <div className={styles.options}>
            <SelectOptions />
            <SelectLang isLogin={false} />
          </div>
        )}
      </header>
    </>
  );
}
